import React from "react";

const FujairahTextSection = ({ title, paragraphs }) => {
  return (
    <section className="ft-text-section">
      <div className="container">
        <div
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {paragraphs.map((p, i) =>
            p && p.subheading ? (
              <h3 key={i} className="ft-text-subheading">{p.subheading}</h3>
            ) : p && p.list ? (
              <ul key={i} className="ft-text-list">
                {p.list.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            ) : (
              <p key={i} className="ft-text-para">{p}</p>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default FujairahTextSection;
